import ViewSurveyDialog from './viewSurveyDialog.container'

export default ViewSurveyDialog